import AEMWrapper from "aem/ComponentWrapper";
import loadable from "@loadable/component";
import React from "react";

export default AEMWrapper(
  {
    type: "rh/components/content/rhtypography",
    config: {
      emptyLabel: "rhtypography",
      isEmpty: _ => false
    }
  },
  loadable(
    () => import(/* webpackChunkName: "component-rh-typography" */ "."),
    {
      fallback: <></>
    }
  )
);
